import React from "react";
import {CircularProgress} from "@/component/view/CircularProgress";

export function LoadingFull() {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
            }}
        >
            <CircularProgress size={40}/>
        </div>
    );
}
